/**
 * This service contains all kinds of info that might be needed for templates and such.
 * Examples are www/cdn url, device category, links to the apps and so on.
 * Any meta tag with the prefix in SITE_CONFIG_KEY will be picked up by the
 * settings service. The name of the value will be whatever follows the config key.
 */
export default {
    name: 'sitesettings',
    callable() {
        const SITE_CONFIG_KEY = 'sitesettings.';
        return _loadSiteSettings();

        function _loadSiteSettings() {
            return Array.from(
                document.querySelectorAll('meta')
            ).reduce((settings, ele) => {
                const name = ele.getAttribute('name');
                const value = ele.getAttribute('content');
                if (name && value && name.indexOf(SITE_CONFIG_KEY) === 0) {
                    settings[name.slice(SITE_CONFIG_KEY.length)] = value;
                }
                return settings;
            }, {});
        }
    },
};



// WEBPACK FOOTER //
// ./services/sitesettingsservice.js